import {useEffect, useState} from 'react';
import Debounce from 'lodash/debounce';

export const useResize = (): number => {
  const [currentWidth, setCurrentWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = (e: UIEvent) => {
      if (e.target) {
        const win = e.target as Window;

        setCurrentWidth(win.innerWidth);
      }
    };

    const debouncedHandleResize = Debounce(handleResize, 20);

    window.addEventListener('resize', debouncedHandleResize);

    return () => {
      window.removeEventListener('resize', debouncedHandleResize);
    };
  }, []);

  return currentWidth;
};
